import React from "react";
import YContactPageLeft from "../components/YContactPageLeft";
import YContactPageRight from "../components/YContactPageRight";
import ContactPageSwiper from "../components/ContactPageSwiper";
import ContactPageMap from "../components/ContactPageMap";
import ContactPageNewsLetter from "../components/ContactPageNewsLetter";
import Footer from "../../Footer/Footer";

function ContactPage() {
  return (
    <>
      <div className="Ycontainer">
        <div className="yContactUsPage">
          <ContactPageMap />
          <div className="YglobalFlex contactPageFlex">
            <YContactPageLeft />
            <YContactPageRight />
          </div>
          {/* <ContactPageSwiper /> */}
          {/* <ContactPageNewsLetter /> */}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ContactPage;
